module.exports = "//img1.rrcimg.com/_next/static/src/assets/yc_3qQVx.png";